import { Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';
import Tabs, { TabContent, TabItem, TabPanel } from 'components/Input/Tab';
import React, { useContext, useEffect, useRef, useState } from 'react'
import ContentWrapper from 'view/FrontEnd/Project/components/ContentWrapper';
import SpendingPlanProgress from './SpendingPlan/SpendingPlanProgress';
import WorkPlanProgress from './WorkPlan/WorkPlanProgress';
import { TextAreaItem } from 'components/Input/TextArea';
import { Convert, DefaultArrayEmpty, FnAxios, FnDialog, formatNumber } from 'utilities/utilities';
import { ApiProject } from 'enum/api';
import { NullLogger } from '@microsoft/signalr';
import { ProjectUpdateProgressContext } from './UpdateProgressPlan';
import UploadFileItem from 'components/Input/UploadFile';
import { EnumProjectStatusID } from 'enum/enum';

const TabQuater = (props) => {
    const {
        nProjectID,
        isPermission,
        ObjProjectRequest,
        nStatusID,
        ObjStepFlowProject,
        isModeSecretary,
        nQuaterID,
        setnQuaterID,
        set_lstProjectWorkPlan,
        set_lstProjectSpendingPlanType,
        _nProgressStatusID,
        set_nProgressStatusID,
        _nUpdateProgressStatusID,
        set_nUpdateProgressStatusID,
        isQuaterEnd,
        isEdit,
        arrYear,
        nProgressID,
        setnProgressID,
        nCurrentQ,
        isEditSecretary,
        lstFileSpendingPlan_1,
        setlstFileSpendingPlan_1,
        lstFileSpendingPlan_2,
        setlstFileSpendingPlan_2,
    } = useContext(ProjectUpdateProgressContext);

    const { tabid, nQuarter, nYearID, isDisabledQuater, nCurrentYear, isEditProgressOld } = props;

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const sBackgroundTab = "rgb(54 131 14)";
    const sBackgroundTabActive = "linear-gradient(rgb(52 206 37) 33%, rgb(92 224 62 / 57%) 71%, rgb(138 255 111 / 68%) 87%, rgb(255, 255, 255) 100%)";
    const [tabInQuaterID, setTabInQuaterID] = useState("TabWorkPlan" + nQuarter);

    const [ObjDataProject, setObjDataProject] = useState<any>(null);
    const [dStartProject, setdStartProject] = useState<any>(null);
    const [dEndProject, setdEndProject] = useState<any>(null);
    const [isPlan, setisPlan] = useState(true);

    const [lstProjectWorkPlan, setlstProjectWorkPlan] = useState([]);
    const [sActivitySummarize, setsActivitySummarize] = useState<any>(null);
    const [lstSummaryPlanYearWorkPlan, setlstSummaryPlanYearWorkPlan] = useState([]); //แผน
    const [lstSummaryYearWorkPlan, setlstSummaryYearWorkPlan] = useState([]); //ผล

    const [lstProjectSpendingPlanType, setlstProjectSpendingPlanType] = useState([]);
    const [lstSummaryPlanYearSpendingPlan, setlstSummaryPlanYearSpendingPlan] = useState([]); //แผน
    const [lstSummaryYearSpendingPlan, setlstSummaryYearSpendingPlan] = useState([]); //ผล

    // const [lstFileSpendingPlan_1, setlstFileSpendingPlan_1] = useState([]); //เอกสารแนบ << รายละเอียดรายงานผลการใช้จ่ายเงิน กท.3/1 > รายไตรมาส
    // const [lstFileSpendingPlan_2, setlstFileSpendingPlan_2] = useState([]); //เอกสารแนบ << แบบรายงานสรุปผลการดำเนินงานรายไตรมาส กท.3/1 > รายไตรมาส
    const onClearFile_SpendingPlan_1 = useRef(null);
    const onClearFile_SpendingPlan_2 = useRef(null);

    useEffect(() => {
        if (nYearID !== null && nQuarter !== 0) handleGetFormProjectID();
    }, [nYearID, nQuarter, nProgressID]);

    const handleGetFormProjectID = () => {
        if (onClearFile_SpendingPlan_1) onClearFile_SpendingPlan_1.current(null);
        if (onClearFile_SpendingPlan_2) onClearFile_SpendingPlan_2.current(null);

        let param = {
            nProjectID: nProjectID,
            nYearID: nYearID,
            nQuarter: nQuarter,
            lstnYear: DefaultArrayEmpty((arrYear || []).map(m => Convert.StringToInt(m.value))),
        };
        AxiosFn.Post(ApiProject.GetFormProjectID_Quater, param, (result) => {
            setdStartProject(result.nStartProjectDate ? new Date(result.nStartProjectDate) : null);
            setdEndProject(result.nEndProjectDate ? new Date(result.nEndProjectDate) : null);
            setObjDataProject(result.ObjDataProject);

            set_nProgressStatusID(result.nProgressStatusID);
            set_nUpdateProgressStatusID(result.nUpdateProgressStatusID);
            setnQuaterID(nQuarter);
            setnProgressID(result.nProgressID);

            //isPlan >> โหมด T = WorkPlan | F = SpendingPlan
            setlstProjectWorkPlan(result.lstProjectWorkPlan ?? []);
            setsActivitySummarize(result.sActivitySummarize);
            setlstSummaryPlanYearWorkPlan(result.lstSummaryPlanYearWorkPlan ?? []); //แผน
            setlstSummaryYearWorkPlan(result.lstSummaryYearWorkPlan ?? []); //ผล

            setlstProjectSpendingPlanType(result.lstProjectSpendingPlanType ?? []);
            setlstSummaryPlanYearSpendingPlan(result.lstSummaryPlanYearSpendingPlan ?? []); //แผน
            setlstSummaryYearSpendingPlan(result.lstSummaryYearSpendingPlan ?? []); //ผล      

            setlstFileSpendingPlan_1(result.lstFileSpendingPlan_1 ?? []); //เอกสารแนบ << รายละเอียดรายงานผลการใช้จ่ายเงิน กท.3/1 > รายไตรมาส
            setlstFileSpendingPlan_2(result.lstFileSpendingPlan_2 ?? []); //เอกสารแนบ << แบบรายงานสรุปผลการดำเนินงานรายไตรมาส กท.3/1 > รายไตรมาส
        });
    };

    const [isEditProgress, setisEditProgress] = useState(false);
    const [isEditSecretaryProgressOld, setisEditSecretaryProgressOld] = useState(false); // Enh.2025 > เลขา กดบันทึกและยอมรับผล : ยังสามารถแก้ไข Q ไตรมาสที่ผ่านมาได้ < แก้ไขได้ กท 3/1 - แท็บ รายงานผลการปฎิบัติงาน: แก้ไขได้ทั้งหมด แสดงปุ่ม บันทึก - แท็บ รายงานผลการใช้จ่ายเงิน: แก้ไขไม่ได้ 

    useEffect(() => {
        setisEditProgress(isEdit === true && isDisabledQuater === false && (nYearID === nCurrentYear && nQuarter === nCurrentQ) ? true : false);

        // Enh.2025 > เปลี่ยนจาก แก้ไขไม่ได้และไม่มีปุ่มอะไร ได้แค่ดูจนกว่าจะถึงช่วงวันให้อัพเดตไตรมาสถัดไป เป็น เลขา กดบันทึกและยอมรับผล : ยังสามารถแก้ไข Q ไตรมาสที่ผ่านมาได้ < แก้ไขได้ กท 3/1 - แท็บ รายงานผลการปฎิบัติงาน: แก้ไขได้ทั้งหมด แสดงปุ่ม บันทึก - แท็บ รายงานผลการใช้จ่ายเงิน: แก้ไขไม่ได้ 
        // หากมีข้อมูลที่ต้องการเพิ่มในไตรมาสที่ 1 แต่มาถึงช่วงเวลาของการรายงานไตรมาสที่ 2 แล้ว ต้องการให้เพิ่มข้อมูลในไตรมาสที่ 1 ได้ เนื่องจากอาจเป็นข้อมูลสำคัญ
        // > หากจะเพิ่มข้อมูลในส่วนของไตรมาส 1 ต้องการให้เปิดแก้ไขเฉพาะผลของการดำเนินงานเท่านั้น (ไม่สามารถแก้ไขส่วนของแผนการดำเนินงาน แผนการใช้เงิน และผลการใช้เงินได้)
        // = กรณีที่เลยช่วงระยะเวลาไตรมาสเดิมไปแล้ว ระบบจะเปิดให้แก้ไขข้อมูลของไตรมาสเดิมได้เฉพาะผลการดำเนินงาน ส่วนแผนและผลการใช้เงินไม่สามารถปรับแก้ไขได้
        // เลขา >> บันทึก : อัพเดตไตรมาส จาก Q ปัจุบัน - 1 กับ Q ปัจุบัน ที่มีการกดบันทึกยอมรับผลไปแล้ว
        //// const isCurrentYear = nYearID === nCurrentYear ? (nQuarter === (nCurrentQ - 1) || nQuarter === nCurrentQ) : nYearID < nCurrentYear && nCurrentQ === 1 ? nQuarter === 4 : false;
        let isCurrentYear = false;
        if (isEditProgress) {
            // ถึงระยะ รายงาน Q ปัจุบัน
            isCurrentYear = nYearID === nCurrentYear ? nQuarter === (nCurrentQ - 1) : nYearID < nCurrentYear && nCurrentQ === 1 ? nQuarter === 4 : false;
        } else if (!isEditProgress) {
            // ยังไม่ถึงระยะ รายงาน Q ปัจุบัน
            if (nYearID === nCurrentYear) {
                // ปีนี้
                isCurrentYear = nQuarter === (nCurrentQ - 1) || nQuarter === (nCurrentQ - 2) ? true : false;
            } else if (nYearID < nCurrentYear) {
                // ปีที่แล้ว
                //// isCurrentYear = nQuarter === 4 ? true : nQuarter === 3 ? true : false;
                isCurrentYear = nCurrentQ === 1 ? ((nQuarter === 4 || nQuarter === 3) ? true : false) : ((nCurrentQ === 2 && nQuarter === 4) ? true : false);
            }
        }
        const arrNotEditProgres = [25, 26, 27, 28, 29, 33, 36]; //_nProgressStatusID
        if (isEditProgressOld && isModeSecretary === true && isCurrentYear && isPermission && !arrNotEditProgres.includes(_nProgressStatusID)) setisEditSecretaryProgressOld(true); //&& !isQuaterEnd

    }, [isEdit, nCurrentQ, isDisabledQuater]);

    return (
        <Grid item xs={12} md={12} container spacing={2} alignItems={"flex-start"} justifyItems={"center"} style={{ padding: '1%', paddingBottom: '1%', }}>
            <Grid item xs={12}>
                <Typography variant='h6' color={'#0056b6'} textAlign={"center"}>
                    แบบรายงานผลการดำเนินงานโครงการที่ได้รับการสนับสนุนเงินจากกองทุนจัดการซากดึกดำบรรพ์
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <ContentWrapper
                    style={{
                        border: '0px solid #f1f1f1 !important',
                        borderRadius: '10px',
                        paddingBottom: '1%',
                        paddingTop: '2%',
                        backgroundColor: 'aliceblue',
                    }}
                >
                    <Grid container spacing={1} justifyContent={"center"}>
                        <Grid item>
                            <Typography fontWeight={700} textAlign={"center"}>{"รายงานครั้งที่  " + (ObjDataProject?.nReportNo ?? "1") + " ปีบัญชี  " + (parseInt(nYearID) + 543)}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography fontWeight={700} textAlign={"center"}>ณ สิ้นไตรมาส</Typography>
                        </Grid>
                        <Grid item>
                            <FormControl sx={{ m: 3, backgroundColor: 'transparent' }} component="fieldset" variant="standard" disabled>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={nQuarter === 1} name="Q1" />
                                        }
                                        label="(มกราคม - มีนาคม)"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={nQuarter === 2} name="Q2" />
                                        }
                                        label="(เมษายน - มิถุนายน)"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={nQuarter === 3} name="Q3" />
                                        }
                                        label="(กรกฎาคม - กันยายน)"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={nQuarter === 4} name="Q4" />
                                        }
                                        label="(ตุลาคม - ธันวาคม)"
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </ContentWrapper>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={2}><Typography fontWeight={700}>ชื่อโครงการ</Typography></Grid>
                    <Grid item xs={12} md={10}>{ObjDataProject?.sProjectName ?? " - "}</Grid>
                    <Grid item xs={12} md={2}><Typography fontWeight={700}>หน่วยงานที่รับผิดชอบ</Typography></Grid>
                    <Grid item xs={12} md={10}>{ObjDataProject?.sUnitTypeName ?? " - "}</Grid>
                    <Grid item xs={12} md={2}><Typography fontWeight={700}>ระยะเวลาดำเนินการ</Typography></Grid>
                    <Grid item xs={12} md={10}>{ObjDataProject?.sDateProjectStartEnd ?? " - "}</Grid>
                    <Grid item xs={12} md={2}><Typography fontWeight={700}>วงเงิน</Typography></Grid>
                    {/* <Grid item xs={12} md={9}>{ObjDataProject?.nApproveBudget ?? " - "} <span style={{fontWeight:'700'}}> บาท </span>{ObjDataProject?.sBudgetThaiBaht ? ("(" + ObjDataProject?.sBudgetThaiBaht + ")" ) : ""}</Grid> */}
                    <Grid item xs={12} md={10}>
                        {ObjDataProject?.nApproveBudget != null ?
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item><Typography variant='body1'>{formatNumber(ObjDataProject?.nApproveBudget, 2) ?? " - "}</Typography></Grid>
                                <Grid item><Typography variant='body1' fontWeight="bold">บาท</Typography></Grid>
                                <Grid item><Typography variant='body1'>{"(" + (ObjDataProject?.sBudgetThaiBaht ?? "แสดงวงเงินตัวอักษรภาษาไทย") + ")"}</Typography></Grid>
                            </Grid>
                            :
                            <Typography variant='body1'>{" - "}</Typography>
                        }
                    </Grid>
                    <Grid item xs={12} md={2}><Typography fontWeight={700}>ระยะเวลารายงานผล</Typography></Grid>
                    <Grid item xs={12} md={10} style={{ color: 'red' }}>
                        {ObjDataProject?.sDateStartEnd ??
                            (nQuarter === 1 ? ("01/03/" + (parseInt(nYearID) + 543) + " - 15/04/" + (parseInt(nYearID) + 543))
                                : (nQuarter === 2 ? ("01/06/" + (parseInt(nYearID) + 543) + " - 15/07/" + (parseInt(nYearID) + 543))
                                    : (nQuarter === 3 ? ("01/09/ " + (parseInt(nYearID) + 543) + " - 15/10/" + (parseInt(nYearID) + 543))
                                        : (nQuarter === 4 ? ("01/11/" + (parseInt(nYearID) + 543) + " - 15/01/" + (parseInt(nYearID + 1) + 543)) : ""))))
                        }
                    </Grid>
                    <Grid item xs={12} md={2}><Typography fontWeight={700}>รายงานผลวันที่</Typography></Grid>
                    <Grid item xs={12} md={10}>{ObjDataProject?.sDateActualPeriod ?? " - "}</Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} container spacing={1} alignItems={"center"} justifyItems={"center"} style={{ paddingBottom: '1%', }}>
                <Tabs id={"TabQuater" + nQuarter} defaultTab={tabInQuaterID} onTabChange={(e) => { setTabInQuaterID(e); setisPlan(e.includes("TabWorkPlan") ? true : false); }}>
                    <TabItem
                        id={"TabWorkPlan" + nQuarter}
                        isSub={true}
                        idHeadSub={tabid}
                        sBackgroundTab={sBackgroundTab}
                        sBackgroundTabActive={sBackgroundTabActive}
                    >
                        รายงานผลการปฎิบัติงาน
                    </TabItem>
                    <TabItem
                        id={"TabSpendingPlan" + nQuarter}
                        isSub={true}
                        idHeadSub={tabid}
                        sBackgroundTab={sBackgroundTab}
                        sBackgroundTabActive={sBackgroundTabActive}
                    >
                        รายงานผลการใช้จ่ายเงิน
                    </TabItem>
                    <TabContent id={"TabQuater"}>
                        <TabPanel
                            id={"TabWorkPlan" + nQuarter}
                            isSub={true}
                            idHeadSub={tabid}
                        >
                            <WorkPlanProgress
                                nYear={nYearID}
                                tabid={tabid}
                                nQuarter={nQuarter}
                                lstProjectWorkPlanAll={lstProjectWorkPlan}
                                sActivitySummarize={sActivitySummarize}
                                lstSummaryPlanYearWorkPlan={lstSummaryPlanYearWorkPlan} //แผน
                                lstSummaryYearWorkPlan={lstSummaryYearWorkPlan} //ผล
                                isEditSecretaryProgressOld={isEditSecretaryProgressOld}
                            />
                        </TabPanel>
                        <TabPanel
                            id={"TabSpendingPlan" + nQuarter}
                            isSub={true}
                            idHeadSub={tabid}
                        >
                            <SpendingPlanProgress
                                nYear={nYearID}
                                tabid={tabid}
                                nQuarter={nQuarter}
                                lstProjectSpendingPlanTypeAll={lstProjectSpendingPlanType}
                                lstSummaryPlanYearSpendingPlan={lstSummaryPlanYearSpendingPlan} //แผน
                                lstSummaryYearSpendingPlan={lstSummaryYearSpendingPlan} //ผล   
                            />
                        </TabPanel>
                    </TabContent>
                </Tabs>
            </Grid>
            <Grid item xs={12} md={12} container spacing={2} alignItems={"flex-start"} justifyContent={"center"} style={{ padding: '1%', }}>
                <Grid item xs={12} style={{ paddingBottom: '1%', }}>
                    <UploadFileItem
                        required={true}
                        modeDisplay={"list"}
                        id={`oFileSpendingPlan_1`}
                        name={`oFileSpendingPlan_1`}
                        label={"แบบรายงานผลการดำเนินงานโครงการ (แบบ กท. 3/1)"} //Enh.2025 เปลี่ยนชื่อ รายละเอียดรายงานผลการใช้จ่ายเงิน เป็น แบบรายงานผลการดำเนินงานโครงการ (แบบ กท. 3/1)
                        arrFile={lstFileSpendingPlan_1}
                        setarrFile={setlstFileSpendingPlan_1}
                        Extension={["pdf", "jpg", "jpe", "png", "doc", "doc", "xls", "xls", "rar", "zip",]}
                        IsFolder={false}
                        onClearFile={onClearFile_SpendingPlan_1}
                        sFolderTemp="Project"
                        IsMultiple={true}
                        nLimitFile={30}
                        sLimitFile="MB"
                        sPositionText="right"
                        IsCrop={true}
                        cropShape={"retangle"}
                        cropRatio={16 / 9}
                        cropResize={true}
                        cropMovable={true}
                        disabled={isEditSecretaryProgressOld ? false : (isEditSecretary === true) ? false : !isEditProgress}
                    />
                </Grid>
                <Grid item xs={12}>
                    <UploadFileItem
                        required={true}
                        modeDisplay={"list"}
                        id={`oFileSpendingPlan_2`}
                        name={`oFileSpendingPlan_2`}
                        label={"เอกสารประกอบการเบิกจ่าย"} //Enh.2025 เปลี่ยนชื่อ แบบรายงานสรุปผลการดำเนินงานรายไตรมาส เป็น เอกสารประกอบการเบิกจ่าย
                        arrFile={lstFileSpendingPlan_2}
                        setarrFile={setlstFileSpendingPlan_2}
                        Extension={["pdf", "jpg", "jpe", "png", "doc", "doc", "xls", "xls", "rar", "zip",]}
                        IsFolder={false}
                        onClearFile={onClearFile_SpendingPlan_2}
                        sFolderTemp="Project"
                        IsMultiple={true}
                        // nLimitFile={30}
                        nLimitFile={100}
                        sLimitFile="MB"
                        sPositionText="right"
                        IsCrop={true}
                        cropShape={"retangle"}
                        cropRatio={16 / 9}
                        cropResize={true}
                        cropMovable={true}
                        //// disabled={(isEditSecretary === true) ? false : !isEditProgress}
                        disabled={isEditSecretaryProgressOld ? false : (isEditSecretary === true) ? false : !isEditProgress}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default TabQuater